import React from "react";
import { Box, Container, Typography, Button, useMediaQuery, withWidth } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
// import Image from "../Images/UlapRecPictures/1.jpg";

const useStyles = makeStyles((theme) => ({
    title: {
        paddingTop: "30px",
        fontSize: "50px",
        fontWeight: "bold",
        marginBottom: "10px",
        textAlign: "center",
        [theme.breakpoints.down("md")]: {
            fontSize: "40px",
        },
        [theme.breakpoints.down("sm")]: {
            textAlign: "left",
            fontSize: "30px",
        },
    },
    description: {
        fontSize: "20px",
        marginBottom: "20px",
        textAlign: "center",
        [theme.breakpoints.down("md")]: {
            fontSize: "16px",
        },
        [theme.breakpoints.down("sm")]: {
            textAlign: "justify",
            fontSize: "16px",
        },
    },
    button: {
        color: "white",
        backgroundColor: "#FF7707",
        padding: "10px 20px",
        textTransform: "none",
        [theme.breakpoints.down("md")]: {
            padding: "9px 18px",
            fontSize: "16px",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            padding: "8px 16px",
            fontSize: "14px",
        },
    },
    centeredBox: {
        [theme.breakpoints.down("md")]: {
            padding: "15px",
        },
        [theme.breakpoints.down("sm")]: {
            padding: "10px",
        },
    },
    highlight: {
        color: "#FF7707",
    },
    buttonContainer: {
        textAlign: "center",
    },
}));

function Problem() {
    const classes = useStyles();
    // const theme = useTheme();
    // const isTablet = useMediaQuery(theme.breakpoints.down("md"));
    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Container>
            <Box className={classes.centeredBox}>
                <Typography className={classes.title}>
                    Struggling with<span className={classes.highlight}> HR Overload</span>
                </Typography>
                <Typography className={classes.description}>
                    Slow, disorganized hiring drains your time and resources. Poor onboarding leaves new hires feeling lost—and your team picking up the slack. 
                    The result? Frustration, wasted potential, and slower growth. Every day this continues, you lose money, momentum, and maybe even great talent. 
                    But it doesn’t have to be this way.
                </Typography>
                <Box className={classes.buttonContainer}>
                    <Button className={classes.button}>
                        There's a Better Way
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}

export default Problem;
